import { Close } from '@mui/icons-material';
import {
  Box,
  Divider,
  Grid,
  IconButton,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from '@mui/material';
import { DateTime } from 'luxon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  activityLogDataProcess,
  stepsModifier,
} from '../helpers/activityLogDataProcess';
import { fromDBToLocalTimestamp } from '../helpers/date';
import GenButton from './GenButton';

const VehicleActivityLogIterator = activities =>
  activityLogDataProcess(activities)?.map((activity, index) => (
    <Step key={index}>
      <StepLabel icon={activityLogDataProcess(activities).length - index}>
        <Box>
          <Typography variant="body2" color="secondaryText">
            {activity.title}
          </Typography>
        </Box>
        <Box>
          <Typography variant="caption" color="text.disabled">
            {activity.date}
          </Typography>
        </Box>
        <Box sx={{ maxWidth: '200px', whiteSpace: 'nowrap' }}>
          <Box
            component="div"
            sx={{
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
          >
            <Typography variant="caption" color="text.disabled">
              {activity.name}
            </Typography>
          </Box>
        </Box>
      </StepLabel>
    </Step>
  ));

const NormalOrderActivityLogIterator = steps =>
  stepsModifier(steps).map((step, index) => (
    <Step key={index}>
      <StepLabel icon={steps.length - index}>
        <Box>
          <Typography variant="body2" color="secondaryText">
            {step.step}
          </Typography>
        </Box>
        <Box>
          <Typography variant="caption" color="text.disabled">
            {fromDBToLocalTimestamp(step?.createdAt, DateTime.DATETIME_SHORT)}
          </Typography>
        </Box>
        <Box sx={{ maxWidth: '200px', whiteSpace: 'nowrap' }}>
          <Box
            component="div"
            sx={{
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
          >
            <Typography variant="caption" color="text.disabled">
              {[step?.person?.firstName, step?.person?.lastName]
                .filter(x => x)
                .join(' ')}
            </Typography>
          </Box>
        </Box>
      </StepLabel>
    </Step>
  ));

const ActivityLogContentStructure = ({
  closeModal,
  data,
  isVehicle,
  steps,
}) => {
  const { t } = useTranslation('workOrderStepper');
  return (
    <>
      <Grid
        container
        sx={{
          borderRadius: '4px',
          overflow: 'hidden',
          backgroundColor: theme => theme.palette.background.paper,
          maxWidth: '304px',
          boxShadow: theme => theme.shadows[10],
          flexDirection: 'column',
          minHeight: '450px',
          minWidth: { lg: '504px' },
        }}
      >
        <Grid item>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              backgroundColor: theme => theme.palette.grey[50],
              padding: theme => theme.spacing(2, 0, 2, 2),
              borderBottom: theme => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Grid item>
              <Typography variant="h6">
                {t('wOStepperActivityPopUp.title')}
              </Typography>
            </Grid>
            <Grid item>
              <IconButton aria-label="close" onClick={closeModal} size="large">
                <Close />
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
        <Grid item sx={{ flex: 1 }}>
          <Grid
            container
            direction="column"
            alignItems="stretch"
            sx={{ padding: theme => theme.spacing(2, 2, 0, 2) }}
          >
            <Grid item>
              <Box
                sx={{
                  maxWidth: '100%',
                  height: '481px',
                  overflowY: 'auto',
                  padding: theme => theme.spacing(2),
                }}
              >
                <Stepper orientation="vertical">
                  {isVehicle && data && VehicleActivityLogIterator(data)}
                  {!isVehicle && steps && NormalOrderActivityLogIterator(steps)}
                </Stepper>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Divider />
        <Grid item>
          <Grid
            container
            sx={{ justifyContent: 'end', padding: theme => theme.spacing(2) }}
          >
            <Grid item sx={{ marginRight: theme => theme.spacing(2) }}>
              <GenButton
                size="large"
                variant="outlined"
                sx={{
                  color: theme => theme.palette.text.primary,
                  borderColor: theme => theme.palette.divider,
                }}
                text={t('wOStepperActivityPopUp.button')}
                onClick={closeModal}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default ActivityLogContentStructure;
